import { render, staticRenderFns } from "./AdminEditarParticipaciones.vue?vue&type=template&id=7056fd6c&"
import script from "./AdminEditarParticipaciones.vue?vue&type=script&lang=js&"
export * from "./AdminEditarParticipaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports